import {useState, useContext} from 'react';
import {UserContext, UpdateUserContext} from "../../App"
import './Devoirs.css'
import {tab_color_bg} from "../config/Config"
import {Etiquette} from "./Etiquette"
import {Modal} from "../question/Modal"

export function Devoirs ({auth, updateUser}) {
  const {currentUser} = useContext(UserContext)
  const user = currentUser
  const updateUsercontext = useContext(UpdateUserContext)
  const [show_activite, setShow_activite] = useState(false)

  // Dates
  const dat = new Date()
  const dat_month = dat.getMonth()+1 < 10 ? '0'+ (dat.getMonth()+1) : dat.getMonth()+1
  const dat_day = dat.getDate() < 10 ? '0'+ (dat.getDate()) : dat.getDate()
  const today = dat.getFullYear() + '-' + dat_month + '-' + dat_day
  const cleanDate = (date) => date.slice(-2)+'/'+date.slice(-5,-3)

  const [devoir_cree, setDevoir_cree] = useState({
    classe:'',
    nb_question:'3',
    etoile:'',
    niveau:'',
    titre:'',
    titre_active:false,
    comm_active:'',
    info_diff:false,
    champ_valid:true,
    optionnel:'Non',
    date_limit:'Non',
    date_limit_value:today,
    notion:[],
    selection:{},
    search:'',
    config_supp:'',
    config_supp_active:false,
    mode_aleatoire:true,
    replayable:'∞',
    nbEssaisMin:1,
    etape:1,
  })

  
  let current_classe = ''
  const add_br = (classe) => {
    if(current_classe !== classe) {
      current_classe = classe
      return <br/>
    }
  }
  
  let color_devoir = {}
  
  let k = 0
  user.liste_classes?.forEach(c => {
    color_devoir = {...color_devoir, [c]:tab_color_bg[k]}
    k++
  })
  
  //console.log(user)
  return (
    <div>
      {user.mes_devoirs.length ? 
      <div id="liste_devoirs" className="content max" style={{textAlign:"left"}} >
        <h1>Mes {user.mes_devoirs.length} devoirs en cours</h1>
        {
          user.mes_devoirs.length > 9 && <span style={{color:'steelblue'}}>ℹ️ La suppression de la demande de faire un devoir ne supprime pas les résultats de ce devoir.</span>
        }
        <div >
         {user.mes_devoirs.map((devoir, k) => 
          <span key ={k}>
            {add_br(devoir.classe)}

            <Etiquette key={k} user={user} auth={auth} devoir={devoir} classes={user.liste_classes} k={k} updateUsercontext={updateUsercontext} setShow_activite={setShow_activite} setDevoir_cree={setDevoir_cree} />
            
          </span>
          )}
        </div>
      </div>
      : <>
          <br/><br/><br/><br/><br/>
          <div className="info"><br/>Vous n'avez pas de demande de faire un devoir.<br/><br/></div>
        </>
      }
      {show_activite ? 
        <Modal auth={{...auth, profil:user.profil, notion:devoir_cree.notion, nb_question:devoir_cree.nb_question, etoile:devoir_cree.etoile ? devoir_cree.etoile : '0', activite:devoir_cree.notion.join('__'), niveau:devoir_cree.niveau, listeChoix:devoir_cree.listeChoix}} setShow_activite={setShow_activite} />
          : ''}
      
    </div>
  );
}